export const state = {
    isLoading: false,
    invoice: null,
    isInfoOpened: false,
    accounts: [],
    account: null,
    validation: null,
};
